module.exports = __webpack_public_path__ + "static/media/cross.c630cc27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/PairUnavailable/img/cross.svg
// module id = 162
// module chunks = 0